<template>
    <div class="flex-col ai-end">
        <div class="item-modal flex-col active">
            <div class="item-modal-content grid grid-2-col">
                <template v-for="(partition, i) in partitions" :key="i">
                    <p class="partition-name partition-header"><strong>{{ partition.name }}: </strong></p>

                    <template v-for="(deg, index) in (partition.degradations || [])" :key="index">
                        <p class="degradation-name" :title="deg.annotations || 'Nessuna annotazione'">
                            {{ deg.degradation_type.name }}
                        </p>

                        <div class="status-row" :title="partition.ifr?.name">
                            <StatusTag :color="'#' + partition.ia?.color" label="IA" :height="21" />
                            <StatusTag :color="'#' + partition.ifr?.color" label="IFR" :height="21" />
                                                        <p title="Difettosità Relativa"
                                                             :class="{ 'dr-nullo': isDrNullo(partition.dr?.sum) }">
                                                            DR {{ isDrNullo(partition.dr?.sum) ? 0 : partition.dr?.sum }}
                                                        </p>
                        </div>
                    </template>
                    <p v-if="partition.degradations.length == 0" class="degradation-name">Nessun degrado</p>
                </template>
            </div>
        </div>

        <!-- gap tra i blocchi come nel vecchio flex gap-5 -->
        <div class="row-gap"></div>
    </div>
</template>

<script setup>
import StatusTag from './StatusTag.vue'
import { computed } from 'vue'
import { isDrNullo } from '@/utils'

const props = defineProps({
    params: { type: Object, required: true }
})

const item = computed(() => props.params.data?.item || {})

const partitions = computed(() => item.value?.specificElements || [])
</script>

<style scoped>
.item-modal {
    width: calc(100% - 20px);
    background-color: var(--base-light-color);
    overflow: hidden;
    margin-top: 5px;
}

.item-modal .item-modal-content {
    justify-items: self-start;
    align-items: center;
    padding: 15px 45px;
}

.item-modal .status-tag {
    padding: 0px 10px 0px 5px;
}

.item-modal .partition-name {
    margin: 5px 0;
}

.partition-header {
    grid-column: 1 / -1;
}

.status-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.row-gap {
    height: 5px;
    width: 100%;
}

.dr-nullo {
    color: var(--nullo-color);
    font-style: italic;
}
</style>
